const defaults = {
  supportEmail: "support@tesseract.in",
  grievanceEmail: "grievance@tesseract.in",
  enterpriseSupportEmail: "enterprisesupport@tesseract.in",
};

function readRuntime() {
  if (typeof window === "undefined" || !window.__LEGALDOCS_CONFIG__) {
    return {};
  }
  const c = window.__LEGALDOCS_CONFIG__;
  return {
    supportEmail: c.supportEmail,
    grievanceEmail: c.grievanceEmail,
    enterpriseSupportEmail: c.enterpriseSupportEmail,
  };
}

const runtime = readRuntime();

export const supportEmail = runtime.supportEmail || defaults.supportEmail;
export const grievanceEmail = runtime.grievanceEmail || defaults.grievanceEmail;
export const enterpriseSupportEmail =
  runtime.enterpriseSupportEmail || defaults.enterpriseSupportEmail;

export const legalEmails = {
  supportEmail,
  grievanceEmail,
  enterpriseSupportEmail,
};
